module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_51.80db04f0.mp3";